// extracted by mini-css-extract-plugin
export default {"logo":"DecorLogo_logo__yvdLu","open":"DecorLogo_open__Ibo4x"};